import React from 'react'

const SvgSemaphoreNeutralColor = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 110 110"
        {...props}
    >
        <defs>
            <linearGradient
                id="semaphore_neutral_color_svg__a"
                x1={93.89}
                y1={93.89}
                x2={16.11}
                y2={16.11}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#ff4e00" />
                <stop offset={1} stopColor="#ffd200" />
            </linearGradient>
            <linearGradient
                id="semaphore_neutral_color_svg__b"
                x1={45.88}
                y1={46.9}
                x2={64.09}
                y2={65.11}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#fff" stopOpacity={0} />
                <stop offset={1} stopColor="#221a00" />
            </linearGradient>
        </defs>
        <g
            data-name="Vrstva 2"
            style={{
                isolation: "isolate",
            }}
        >
            <circle
                cx={55}
                cy={55}
                r={55}
                style={{
                    fill: "url(#semaphore_neutral_color_svg__a)",
                }}
            />
            <image
                width={42}
                height={42}
                transform="translate(34.35 35.24)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAAsSAAALEgHS3X78AAAEsklEQVRYR9WY63IaSQxGT+MbNjaO42QT1272/d9rK5vyhhgH8BXM7A/pc2uaAQZIpRJVqcamZtSnv1Gr1ZOqquJ3sf11N7S1lFIqf6t+sBJp23gBLgUvrQq+M/zGsA4p7zS4bN7gFca82aBurWEDpKD2gx/4teP3VBjcDJj6dQa8uM/ZAroVrIN2gD0M7AA4cu+6H5KBBfoMPAJPfn12F/hG0GthU0pS8gAD6gInQA84dT8Bjv2ePQxkCjwA98AEuPO/78ngU7933gZ4JayDSs0uBtgHzoE37n3gDAM+Iiv7hIGN3b+7j/z/O2wyr0qvA15augLoIabaGXABvAv+FgNeBTvBIIfADfDNr0MMfOJDVimllQo3woYcPcBAz4FL4APw0f0P/+0cSwWlgWCVBncY1BADfeP3H2FiyCpgmlJaWuIWYAvQLqbaJXAF/OV+hcFekEGPPJ6qgRaYgC/9/j55YrFyvIRrO1gsgF5/DxvgAwb5N/AJU/aSPLBUikqpTD1jEz4jL8ZD6m+gtthSSqlJ3Rpsg6p9LDc/YrCfgD+B99jr18B75BortaSYKohcqaKJPJDLm4Bfd71opbIR9gQDEuyVX99jamtBRdDSKuqbh9KkqVpMyNXhpUndV9iwQ+1jED1sMbzD8jMuKIFqE4BmWP0ee4e4+MbALVYdbjHgRyzf52WguJfrf8GeYrBvqS+ObUFjvT7FJn3hrvIX02QhZkwDpcA+OWAfCxTLU8xRPbfOdE8UI24w5/7/StiobLm4TlhcxTFH9Uxba1JYW3YPi98lNERlj9yBWr7GmR97kB5Z0dhZbQIq0xgC1jjHZFVjetWsKWdjIPkh+fU0BtrAIrDaS8VfKUY5cBlIvqo8bWIpXONYconROM6uKv0oi/V0aSNTwsZ9eka9w9exZBerwjWOUztBsGScElYBptgOI9ferbPULhYh1RdonJXbbQdeT53x3PRE7pbKJnnl7FdYOYb6gvL0EMeoWVRWgab+YLlv32OT0OvSM21M90VQNeYjchP+SFC37A2aYGf+kALdYp1+bDTi3r0OeBnoGGvIh9TjK90WrOy6YhpMyE3GN3IDo6ZZz5e7oKxcTBH0OxZ34H6DCRNhl7eIVVVVKaWKDHuHwQ7IvUEXq4fJg8VdrcPiAFqQEXToMa/d//PfJti4M2g+7ZbKxryVAl+p79tgORWbb20cpbJa9VHRAfAv8Bn4gsW/xcTRmmhMrRqsqxsX2QiDERDkDv+RfKqNwLISdIy97msM9B8MekBOgaWqwqKykBV5xmYbz1Yv5BQZUT8w6gOHUiR+6JhQf/1fMNBrbAIT8sJdumAXYAt1Y0MR00MdfmzIpa5go6o6ig+wHP1KXlhjcsna/LtBAQw5l+PgN1jelqeHCKtz1ohcAYbYRMvauvYTUiMsQFVVc+99tfPE06iU1beuLrkxj2mgD3ITct3Wdy/VbIGu3cbbfJiLTbka87JpVj/alLNajA/u6gPUJK1VVLYWFhZOErFplseeV1Y2LPJaF9cWFFrCygpoefmBQ8rKBT0PvhGkbCNYWYCGOmRpERq2hJRtBRutPIE22S6A0XaG/Zn2q5zBWtlvBfs/TYtsypskDhUAAAAASUVORK5CYII="
                style={{
                    opacity: 0.8,
                    mixBlendMode: "soft-light",
                }}
            />
            <circle
                cx={54.98}
                cy={56}
                r={12.87}
                style={{
                    fill: "#fff",
                }}
            />
            <circle
                cx={54.98}
                cy={56}
                r={12.87}
                style={{
                    opacity: 0.25,
                    fill: "url(#semaphore_neutral_color_svg__b)",
                }}
            />
        </g>
    </svg>
);

export default SvgSemaphoreNeutralColor;